import { render, staticRenderFns } from "./IconSettingsPlayerSettings.vue?vue&type=template&id=42cf846d&"
import script from "./IconSettingsPlayerSettings.vue?vue&type=script&lang=js&"
export * from "./IconSettingsPlayerSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42cf846d')) {
      api.createRecord('42cf846d', component.options)
    } else {
      api.reload('42cf846d', component.options)
    }
    module.hot.accept("./IconSettingsPlayerSettings.vue?vue&type=template&id=42cf846d&", function () {
      api.rerender('42cf846d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconSettingsPlayerSettings.vue"
export default component.exports